import { getUrl } from './utils'

export const gallery = [
  {
    id: 1,
    text: (
      <p>
        Вход в здание Радио Свобода / Радио Свободная Европа в Мюнхене, 1970-е.{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.svoboda.org/a/rferl-radio-free-europe-75-years-history-photos/33463896.html"
        >
          Штаб-квартира
        </a>{' '}
        РСЕ/РС располагалась в комплексе зданий рядом с парком Английский Сад.
        Передачи из Мюнхена продолжались до переезда в Прагу в 1995 году.
      </p>
    ),
    img: getUrl('/images/gallery/1.webp'),
  },
  {
    id: 2,
    text: (
      <>
        <p>
          Сотрудники Радио Свобода в аппаратной, откуда записи радиопередач на
          разных языках транслировались на территорию СССР и стран Восточной
          Европы. Мюнхен, 1970-е.
        </p>
        <p>
          Радио Свободная Европа и Радио Свобода использовали коротковолновые
          передатчики в Германии, Испании и Португалии, а также управляли
          передающей станцией на Тайване, которая позволяла вещать на территорию
          Сибири.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/2.webp'),
  },
  {
    id: 3,
    text: (
      <p>
        Писатель, в 2000-е годы главный редактор русской службы Радио Свобода{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.svoboda.org/author/%D0%BF%D0%B5%D1%82%D1%80-%D0%B2%D0%B0%D0%B9%D0%BB%D1%8C/piom"
        >
          Петр Вайль
        </a>{' '}
        и{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.svoboda.org/author/%D0%B0%D0%BB%D0%B5%D0%BA%D1%81%D0%B0%D0%BD%D0%B4%D1%80-%D0%B3%D0%B5%D0%BD%D0%B8%D1%81/ypqo"
        >
          Александр Генис
        </a>
        , писатель и сотрудник русской службы РС. 1980 год. Вайль и Генис в
        1970-е{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://archive.svoboda.org/programs/cicles/writers/genis.asp"
        >
          эмигрировали
        </a>{' '}
        из СССР в США, в течение долгих лет были соавторами. Совместно они
        выпустили шесть книг.
      </p>
    ),
    img: getUrl('/images/gallery/3.webp'),
  },
  {
    id: 4,
    text: (
      <>
        <p>
          Вход в здание штаб-квартиры РСЕ/РС на Вацлавской площади, Прага,
          2000-е.
        </p>
        <p>
          Занять здание бывшего Федерального Собрания Чехословакии РСЕ/РС
          предложил первый президент Чешской Республики Вацлав Гавел.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/4.webp'),
  },
  {
    id: 5,
    text: (
      <>
        <p>
          Глава русской службы Радио Свобода (1992 – 1998){' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/a/2280798.html"
          >
            Юрий Гендлер
          </a>{' '}
          в своем офисе в здании на Вацлавской площади. Прага, 1990-е.
        </p>
        <p>
          В 1968 году Юрий Гендлер был арестован КГБ по обвинению в
          &quot;антисоветской деятельности&quot; и приговорен к трем годам
          колонии строгого режима в Мордовии. В 1973 году Гендлер эмигрировал в
          США, через год начал работать на Радио Свобода. В 1980-х он несколько
          лет возглавлял Нью-Йоркское бюро РС.
        </p>
      </>
    ),

    img: getUrl('/images/gallery/5.webp'),
  },
  {
    id: 6,
    text: (
      <p>
        Группа российских журналистов в самолете UNPROFOR (миротворческая
        операция ООН в бывшей Югославии) в аэропорту Сараева. Ирина Лагунина,
        Владимир Ведрашко, Андрей Шарый в 1990-е годы стали сотрудниками русской
        службы РС. Июнь 1993 года.
      </p>
    ),
    img: getUrl('/images/gallery/6.webp'),
  },
  {
    id: 7,
    text: (
      <>
        <p>
          Сотрудники Радио Свобода{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/a/24568943.html"
          >
            Марк Дейч
          </a>
          ,{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D0%B4%D0%BC%D0%B8%D1%82%D1%80%D0%B8%D0%B9-%D0%B2%D0%BE%D0%BB%D1%87%D0%B5%D0%BA/qvq_"
          >
            Дмитрий Волчек
          </a>
          ,{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D0%BC%D0%B8%D1%85%D0%B0%D0%B8%D0%BB-%D1%81%D0%BE%D0%BA%D0%BE%D0%BB%D0%BE%D0%B2/-gqo"
          >
            Михаил Соколов
          </a>
          ,{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D0%B0%D0%BD%D0%B4%D1%80%D0%B5%D0%B9-%D0%B1%D0%B0%D0%B1%D0%B8%D1%86%D0%BA%D0%B8%D0%B9/j_qp"
          >
            Андрей Бабицкий
          </a>
          ,{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D1%81%D0%B0%D0%B2%D0%B8%D0%BA-%D1%88%D1%83%D1%81%D1%82%D0%B5%D1%80/ri__qq/p14"
          >
            Савик Шустер
          </a>{' '}
          и{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/a/1508718.html"
          >
            Владимир Матусевич
          </a>{' '}
          выступают на вечере журнала &quot;Столица&quot;. Москва, 1992.
        </p>
        <p>
          С 1989 по 1996 год Марк Дейч был политическим обозревателем Радио
          Свобода. Дмитрий Волчек – журналист русской службы с 1988 года, первый
          внештатный корреспондент Радио Свобода в России. Михаил Соколов
          сотрудничал с Радио Свобода с 1990 года, в 1991 году во время
          августовского путча Соколов работал в Белом доме. Андрей Бабицкий
          сотрудничал с РС с 1989 по 2014 год, во время чеченских войн был
          корреспондентом в зонах боевых действий. Савик Шустер сотрудничал с РС
          с 1988 по 2001 год, с 1996 по 2001 год Шустер занимал пост директора
          бюро Радио Свобода в Москве. Владимир Матусевич сотрудничал со
          &quot;Свободой&quot; с 1969 года, с 1987 по 1992 год возглавлял
          русскую службу РС.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/7.webp'),
  },
  {
    id: 8,
    text: (
      <p>
        Журналистка российского пула{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.svoboda.org/author/%D0%B8%D1%80%D0%B8%D0%BD%D0%B0-%D0%BB%D0%B0%D0%B3%D1%83%D0%BD%D0%B8%D0%BD%D0%B0/ybi"
        >
          Ирина Лагунина
        </a>{' '}
        в Исфахане в ходе первого после распада СССР визита министра иностранных
        дел России в Иран. Март 1993 года.
      </p>
    ),
    img: getUrl('/images/gallery/8.webp'),
  },
  {
    id: 9,
    text: (
      <p>
        Петр Вайль и писатель Сергей Довлатов. В 1980-е годы{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.svoboda.org/a/24224903.html"
        >
          Довлатов был ведущим
        </a>{' '}
        радиопередач на Радио Свобода. Нью-Йорк, 1981 год.
      </p>
    ),
    img: getUrl('/images/gallery/9.webp'),
  },
  {
    id: 10,
    text: (
      <>
        <p>
          Сотрудники Русской службы Радио Свобода Анатолий Стреляный,{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D1%81%D0%B5%D0%BC%D0%B5%D0%BD-%D0%BC%D0%B8%D1%80%D1%81%D0%BA%D0%B8%D0%B9/kqoy"
          >
            Семен Мирский
          </a>
          , Юрий Гендлер, Марио Корти. Прага, 1998 год.
        </p>
        <p>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D0%B0%D0%BD%D0%B0%D1%82%D0%BE%D0%BB%D0%B8%D0%B9-%D1%81%D1%82%D1%80%D0%B5%D0%BB%D1%8F%D0%BD%D1%8B%D0%B9/ovqy"
          >
            Анатолий Стреляный
          </a>{' '}
          – писатель, сценарист, автор русской службы с 1995 года. Вел
          радиопрограммы &quot;Россия вчера, сегодня, завтра&quot;, &quot;Ваши
          письма&quot;.{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.currenttime.tv/a/budyonnovsk-25-years-journalists/30667672.html"
          >
            Освещал события
          </a>{' '}
          Первой чеченской войны.
        </p>
        <p>
          Журналист, филолог Семен Мирский сотрудничал с РС более полувека – с
          1964 года.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/10.webp'),
  },
  {
    id: 11,
    text: (
      <p>
        Нобелевский лауреат{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.svoboda.org/a/27031209.html"
        >
          Иосиф Бродский
        </a>{' '}
        и Петр Вайль. Лукка, 1995 год. Фото из личного архива Эльвиры Вайль.
        Стихи Бродского впервые прозвучали в эфире Радио Свобода в 1964 году,
        когда поэта в СССР судили по статье &quot;за тунеядство&quot;.
      </p>
    ),
    img: getUrl('/images/gallery/11.webp'),
  },
  {
    id: 12,
    text: (
      <p>
        Слева направо: сотрудники русской службы Радио Свобода{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.svoboda.org/author/%D0%B0%D0%BD%D1%82%D0%BE%D0%BD-%D1%88%D0%B8%D1%80%D1%8F%D0%B5%D0%B2/qrot"
        >
          Антон Ширяев
        </a>
        , Наталья Белова, Валентин Барышников, Лина Ширяева, Иван Толстой,
        Галина Осетрова, Иван Воронцов, Ольга Широкова, Владимир Тольц, Сергей
        Юрьенен,{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.svoboda.org/author/%D0%B0%D0%BB%D0%B5%D0%BA%D1%81%D0%B5%D0%B9-%D1%86%D0%B2%D0%B5%D1%82%D0%BA%D0%BE%D0%B2/mbm_q_"
        >
          Алексей Цветков
        </a>{' '}
        в здании Радио Свобода на Вацлавской площади. Прага, 2000-е.
      </p>
    ),
    img: getUrl('/images/gallery/12.webp'),
  },
  {
    id: 13,
    text: (
      <p>
        Вид на здание РСЕ/РС на Вацлавской площади в Праге. После терактов в США
        11 сентября 2001 года охрана штаб-квартиры медиакорпорации была усилена
        – около года перед зданием дежурили силы быстрого реагирования.
      </p>
    ),
    img: getUrl('/images/gallery/13.webp'),
  },
  {
    id: 14,
    text: (
      <>
        <p>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/a/pri-obyske-ya-sbezhal-cherez-okno-rossiya-mario-korti/32617241.html"
          >
            Марио Корти
          </a>
          , в 1990-е годы заместитель, с 1998-го по 2003 год глава русской
          службы, в здании РСЕ/РС на Вацлавской площади. Прага, 1990-е.
        </p>
        <p>
          Работал на РСЕ/РС с конца 1970-х как аналитик и редактор отдела
          &quot;самиздата&quot;. В 1984 году в Милане он записал{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://tarkovskiy.su/texty/Tarkovskiy/Corti.html"
          >
            беседу
          </a>{' '}
          с режиссером Андреем Тарковским и его женой Ларисой после того, как
          они приняли решение не возвращаться в СССР.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/14.webp'),
  },
  {
    id: 15,
    text: (
      <p>
        Петр Вайль и поэт, журналист русской службы РС Алексей Цветков. Прага,
        2001. Автор фото – историк Радио Свобода Иван Толстой.
      </p>
    ),
    img: getUrl('/images/gallery/15.webp'),
  },
  {
    id: 16,
    text: (
      <>
        <p>
          Сотрудники русской службы Андрей Шарый, Ефим Фиштейн и Владимир
          Ведрашко в здании Радио Свобода на Вацлавской площади. Прага, 2000-е.
        </p>
        <p>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D0%B2%D0%BB%D0%B0%D0%B4%D0%B8%D0%BC%D0%B8%D1%80-%D0%B2%D0%B5%D0%B4%D1%80%D0%B0%D1%88%D0%BA%D0%BE/yiroq"
          >
            Владимир Ведрашко
          </a>{' '}
          сотрудничал с РС с 1996 года. С 2007 года – редактор отдела новостей.{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D0%B5%D1%84%D0%B8%D0%BC-%D1%84%D0%B8%D1%88%D1%82%D0%B5%D0%B9%D0%BD/jpqt"
          >
            Ефим Фиштейн
          </a>{' '}
          сотрудничает с РС с 1982 года. С 2009 по 2012 – директор русской
          службы РС.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/16.webp'),
  },
  {
    id: 17,
    text: (
      <>
        <p>
          Мария Клайн в здании Радио Свобода на Вацлавской площади. Прага,
          2000-е.
        </p>
        <p>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D0%BC%D0%B0%D1%80%D0%B8%D1%8F-%D0%BA%D0%BB%D0%B0%D0%B9%D0%BD/irroi"
          >
            Мария Клайн
          </a>{' '}
          сотрудничала с Радио Свобода с 1993 года. Журналист, редактор отдела
          новостей русской службы. С 2003 по 2009 год – директор русской службы
          РС.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/17.webp'),
  },
  {
    id: 18,
    text: (
      <p>
        Тенгиз Гудава, Петр Вайль, Алексей Цветков, Марио Корти, Антон Ширяев,
        Лина Ширяева и другие журналисты русской службы РС. Прага, 2000-е.
      </p>
    ),
    img: getUrl('/images/gallery/18.webp'),
  },
  {
    id: 19,
    text: (
      <>
        <p>Андрей Шарый. Прага, конец 1990-х.</p>
        <p>
          Андрей Шарый сотрудничает со &quot;Свободой&quot; с 1992 года.
          Внештатный корреспондент в республиках бывшей Югославии. С 1996 года в
          Праге. С 2016 года – директор русской службы. С 2025 – региональный
          директор РСЕ/РС по вещанию в России.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/19.webp'),
  },
  {
    id: 20,
    text: (
      <>
        <p>
          Бывший президент СССР Михаил Горбачев с журналистами русской службы
          Радио Свобода в бюро в Москве, 2002 год.
        </p>
        <p>
          Горбачев неоднократно{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/a/27584572.html"
          >
            был гостем
          </a>{' '}
          программ Радио Свобода. Свое первое интервью он дал РС в 1992 году,
          спустя несколько месяцев после того, как сложил с себя полномочия
          президента уже распавшегося Советского Союза.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/20.webp'),
  },
  {
    id: 21,
    text: (
      <p>
        Слева направо: главный продюсер русской службы РС в 2000-х{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.svoboda.org/author/%D1%80%D1%83%D1%81%D0%BB%D0%B0%D0%BD-%D0%B3%D0%B5%D0%BB%D0%B8%D1%81%D1%85%D0%B0%D0%BD%D0%BE%D0%B2/tiroi"
        >
          Руслан Гелисханов
        </a>
        . Ирина Лагунина (обозреватель Радио Свобода, ведущая аналитических
        программ) и историк Владимир Тольц во внутреннем дворе здания РСЕ/РС на
        Вацлавской площади. Прага, 2000-е.
      </p>
    ),
    img: getUrl('/images/gallery/21.webp'),
  },
  {
    id: 22,
    text: (
      <p>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.svoboda.org/author/%D1%8F%D1%80%D0%BE%D1%81%D0%BB%D0%B0%D0%B2-%D1%88%D0%B8%D0%BC%D0%BE%D0%B2/jji_"
        >
          Ярослав Шимов
        </a>{' '}
        – редактор (1999 – 2013), а затем – глава отдела новостей русской службы
        РС, с 2023 года – главный редактор русской службы. Дейзи Синделар,
        журналист РСЕ/РС, с 2019 по 2022 год занимала пост вице-президента
        медиакорпорации. Прага, 2000-е.
      </p>
    ),
    img: getUrl('/images/gallery/22.webp'),
  },
  {
    id: 23,
    text: (
      <>
        <p>
          Редактор информационной службы РС, международный обозреватель Андрей
          Шароградский и обозреватель русской службы Радио Свобода, автор и
          ведущий программ{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D0%B8%D0%B2%D0%B0%D0%BD-%D1%82%D0%BE%D0%BB%D1%81%D1%82%D0%BE%D0%B9/yup"
          >
            Иван Толстой
          </a>
          . Прага, 2000-е.
        </p>
        <p>
          До переезда и начала работы в штаб-квартире РС в Чехии Андрей
          Шароградский был спецкором русской службы Радио Свобода в Пекине.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/23.webp'),
  },
  {
    id: 24,
    text: (
      <>
        <p>
          Журналист и историк{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D0%B2%D0%BB%D0%B0%D0%B4%D0%B8%D0%BC%D0%B8%D1%80-%D1%82%D0%BE%D0%BB%D1%8C%D1%86/ukqr"
          >
            Владимир Тольц
          </a>
          . Прага, 2000-е.
        </p>
        <p>
          Тольц сотрудничал с Радио Свобода с 1983 года – сначала в Мюнхене,
          затем в Праге. В 1982 году журналиста депортировали из СССР за
          &quot;распространение антисоветских материалов&quot;. Владимир Тольц
          был автором нескольких документальных циклов передач на Радио Свобода,
          в том числе посвященных деятельности КГБ СССР.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/24.webp'),
  },
  {
    id: 25,
    text: (
      <>
        <p>
          Журналист Радио Свобода Сергей Данилочкин в здании штаб-квартиры
          РСЕ/РС на Вацлавской площади. Прага, 2000-е.
        </p>
        <p>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/a/24531445.html"
          >
            Сергей Данилочкин
          </a>{' '}
          сотрудничал с русской службой Радио Свобода с 1997 года. С 2003 года –
          глава иракской службы РСЕ/РС. С 2020 года – главный редактор
          телеканала &quot;Настоящее Время&quot;.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/25.webp'),
  },
  {
    id: 26,
    text: (
      <>
        <p>
          Ведущий и автор программ, поэт{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/author/%D0%B8%D0%B3%D0%BE%D1%80%D1%8C-%D0%BF%D0%BE%D0%BC%D0%B5%D1%80%D0%B0%D0%BD%D1%86%D0%B5%D0%B2/-rqt"
          >
            Игорь Померанцев
          </a>{' '}
          Померанцев начал сотрудничать с Радио Свобода в 1987 году в качестве
          корреспондента в Лондоне. С 1993 по 1995 год работал в Мюнхене, с 1995
          года – в Праге. Автор и ведущий цикла программ &quot;Поверх
          Барьеров&quot; и подкаста &quot;Померанцев переулок&quot;.
        </p>
        <p>
          Иван Толстой сотрудничает с Радио Свобода с 1988 года, с 1995 года – в
          Праге. Автор и ведущий программ{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.svoboda.org/z/211"
          >
            &quot;Поверх барьеров. Мифы и репутации&quot;
          </a>{' '}
          и цикла, посвященного истории Радио Свобода.
        </p>
      </>
    ),
    img: getUrl('/images/gallery/26.webp'),
  },
  {
    id: 27,
    text: (
      <p>
        Сотрудники русской службы Радио Свобода Галина Осетрова, Ирина Лагунина,
        Петр Вайль, Ольга Широкова, Татьяна Пршикрылова и Сергей Сенинский в
        строящейся штаб-квартире РС. Прага, 2009 год
      </p>
    ),
    img: getUrl('/images/gallery/27.webp'),
  },
  {
    id: 28,
    text: (
      <p>
        Журналистка русской службы Радио Свобода{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.svoboda.org/author/%D0%B0%D0%BB%D0%B5%D0%BA%D1%81%D0%B0%D0%BD%D0%B4%D1%80%D0%B0-%D0%B2%D0%B0%D0%B3%D0%BD%D0%B5%D1%80/yrpm"
        >
          Александра Вагнер
        </a>{' '}
        во время командировки в Донбасс. Донецк, 2014 год Александра Вагнер
        начала сотрудничество с Радио Свобода в 2006 году как корреспондент в
        Чешской Республике. Сейчас – автор и редактор информационной службы РС.
      </p>
    ),
    img: getUrl('/images/gallery/28.webp'),
  },
  {
    id: 29,
    text: (
      <p>
        Слева направо: директор вещания РС с 2008 по 2012 год Джон О’Салливан,
        журналист центральной службы новостей РС Андриус Кунчина, президент РС с
        2007 по 2011 год Джеффри Гедмин, первый президент Чешской Республики
        Вацлав Гавел, координатор по связям с общественностью Лариса Балановская
        и бывший глава Чехословацкой службы Радио Свобода Павел Пехачек в
        штаб-квартире РС в Праге. 2009 год.
      </p>
    ),
    img: getUrl('/images/gallery/29.webp'),
  },
]
